"use strict"
//so they are compatible. because export * from 'subschema-prop-types'; does not seem to work.
module.exports = require('subschema-prop-types');



/** WEBPACK FOOTER **
 ** ./~/subschema/src/PropTypes.js
 **/